import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">
        <div className="flex items-center gap-2">
          <span className="typing-dot" />
          <span className="typing-dot" />
          <span className="typing-dot" />
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Force users with a freshly-admin-reset password to set a new one before
  // they can use the app.
  if (
    user.force_password_change &&
    !loc.pathname.startsWith("/change-password")
  ) {
    return <Navigate to="/change-password" replace />;
  }

  if (adminOnly && user.role !== "admin")
    return <Navigate to="/dashboard" replace />;
  return children;
}
